var map = {
	"./1.png": "1925",
	"./1_big.png": "a03e",
	"./2.png": "b461",
	"./2_big.png": "a177",
	"./3.png": "6a37",
	"./3_big.png": "1eb0",
	"./self-1-big.png": "76db",
	"./self-1.png": "53dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e405";